import { useTranslation } from 'react-i18next'
import AvailabilityForm from '../common/AvailabilityForm'
import useDyspozycjaAdd from './hooks/useDyspozycjaAdd'

function DyspozycjaAddPage() {
	const { t } = useTranslation()
	const {
		formError,
		formState,
		handleBack,
		handleFieldChange,
		handleSlotToggle,
		handleCreateSubmit,
		hasExistingEntryForRange,
		rangeEntriesError,
		saving,
	} = useDyspozycjaAdd()

	return (
		<div className="space-y-6">
			<div className="rounded-2xl bg-white p-6 shadow-sm">
				<div className="mb-6 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
					<div>
						<h1 className="text-2xl font-semibold text-gray-900">{t('trainingAvailability.add.title')}</h1>
						<p className="text-sm text-gray-500">{t('trainingAvailability.add.description')}</p>
					</div>
					<button
						type="button"
						onClick={handleBack}
						className="inline-flex items-center rounded-md border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50">
						{t('trainingAvailability.add.actions.back')}
					</button>
				</div>

				{rangeEntriesError && <div className="mb-4 rounded-md bg-yellow-50 p-4 text-sm text-yellow-800">{rangeEntriesError}</div>}
				{hasExistingEntryForRange && (
					<div className="mb-4 rounded-md bg-yellow-50 p-4 text-sm text-yellow-800">
						{t('trainingAvailability.add.messages.duplicateDateRange')}
					</div>
				)}

				<section className="rounded-2xl border border-gray-200 p-4">
					<AvailabilityForm
						formState={formState}
						formError={formError}
						onSubmit={handleCreateSubmit}
						onFieldChange={handleFieldChange}
						onSlotToggle={handleSlotToggle}
						onCancel={handleBack}
						saving={saving}
						submitDisabled={hasExistingEntryForRange}
						mode="create"
					/>
				</section>
			</div>
		</div>
	)
}

export default DyspozycjaAddPage
